import React from 'react'
import MovingSubtitle from '../components/home/MovingSubtitle'
import MainHomeImage from '../components/home/MainHomeImage'
import IntroSection from '../components/home/IntroSection'
import MyApproachSection from '../components/home/MyApproachSection'
import AppLayout from '../App'

function Home() {
  return (
    <AppLayout>
      <MovingSubtitle />
      <MainHomeImage />
      <IntroSection />
      <MyApproachSection />
    </AppLayout>
  )
}

export default Home